<template>
  <div>
    <article class="con4">
      <div class="container">
        <div class="step-wrapper">
          <p class="main-title">채용절차</p>
          <ul>
            <li class="step">01<span>서류전형</span></li>
            <li>▶</li>
            <li class="step">02<span>실무진 면접</span></li>
            <li>▶</li>
            <li class="step">03<span>최종 인터뷰</span></li>
            <li>▶</li>
            <li class="step">04<span>최종합격</span></li>
          </ul>
          <p>* 지원 부문에 따라 추가전형이 진행될 수 있습니다.</p>
        </div>
        <div class="summary-wrapper">
          <p class="main-title">Summary of CARROT</p>
          <ul>
            <li>
              <div>
                <p>James님!</p>
                <img
                  src="@/assets/img/newGlobal/introduce/sub/recruit/con4/img0.jpg"
                  alt="img"
                />
                <p>영어 이름으로 부르는<br /><span>수평적 조직 문화</span></p>
              </div>
            </li>
            <li>
              <div>
                <p>3분!</p>
                <img
                  src="@/assets/img/newGlobal/introduce/sub/recruit/con4/img1.jpg"
                  alt="img"
                />
                <p>신논현,<br />한강진역에서<br /><span>도보 3분!</span></p>
              </div>
            </li>
            <li>
              <div>
                <p>1시간 30분!</p>
                <img
                  src="@/assets/img/newGlobal/introduce/sub/recruit/con4/img2.jpg"
                  alt="img"
                />
                <p>여유로운 점심시간<br /><span>1시간 30분!</span></p>
              </div>
            </li>
            <li>
              <div>
                <p>150개국!</p>
                <img
                  src="@/assets/img/newGlobal/introduce/sub/recruit/con4/img3.jpg"
                  alt="img"
                />
                <p>연간 1회<br /><span>해외여행</span>지원</p>
              </div>
            </li>
            <li>
              <div>
                <p>200만원!</p>
                <img
                  src="@/assets/img/newGlobal/introduce/sub/recruit/con4/img4.jpg"
                  alt="img"
                />
                <p>문화생활/체력단련비<br />연간<span>200만원</span> 지원!</p>
              </div>
            </li>
            <li>
              <div>
                <p>무한!</p>
                <img
                  src="@/assets/img/newGlobal/introduce/sub/recruit/con4/img5.jpg"
                  alt="img"
                />
                <p>당신의 <span>가능성</span>을<br />펼칠 수 있는 기회!</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import "@/assets/style/newGlobalReset.scss";

export default {};
</script>

<style lang="scss" scoped>
.con4 {
  padding: 40px 0;
  background-color: #f7f7f7;

  @media screen and (min-width: 1350px) {
    padding: 80px 0;
  }

  .step-wrapper {
    margin-bottom: 40px;

    .main-title {
      font-size: 20px;
      font-weight: 700;
      text-align: center;
      margin-bottom: 10px;

      @media screen and (min-width: 1350px) {
        font-size: 40px;
      }
    }

    ul {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
      flex-wrap: wrap;
      max-width: 850px;
      margin: 0 auto 30px;

      li {
        &.step {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 180px;
          height: 180px;
          border: 10px solid #e5e5e5;
          border-radius: 300px;
          padding: 45px 0;
          font-size: 17px;
          font-weight: 700;

          &:last-child {
            border: 10px solid #ee9a1f;
          }

          @media screen and (min-width: 1350px) {
            font-size: 20px;
          }

          span {
            font-size: 13px;
            font-weight: 400;

            @media screen and (min-width: 1350px) {
              font-size: 16px;
            }
          }
        }
      }
    }

    > p {
      max-width: 850px;
      margin: 0 auto 30px;
    }
  }

  .summary-wrapper {
    .main-title {
      font-size: 20px;
      font-weight: 700;
      text-align: center;
      margin-bottom: 10px;

      @media screen and (min-width: 1350px) {
        font-size: 40px;
      }
    }

    ul {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      justify-content: center;
      align-items: center;
      gap: 20px;

      @media screen and (min-width: 768px) {
        grid-template-columns: repeat(3, 1fr);
      }

      @media screen and (min-width: 1350px) {
        grid-template-columns: repeat(6, 1fr);
      }

      li {
        align-self: stretch;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 160px;
        max-width: 160px;
        margin: 0 auto;
        padding: 14px;
        background-color: #ffffff;

        div {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
        }

        p {
          font-size: 14px;
          text-align: center;

          span {
            font-weight: 700;
          }
        }
      }
    }
  }
}
</style>
